const moduleName = 'works';

module.exports = () => {

    Array.from(document.querySelectorAll('.js-works')).forEach((self) => {
        if (self.dataset[moduleName + 'Init'] === 'true') return;
        self.dataset[moduleName + 'Init'] = true;

        const holder = self;
        const works = Array.from(holder.querySelectorAll('.js-works-item'));

        works.forEach((work) => {
            work.addEventListener('click', (event) => {
                if (!document.body.classList.contains('mobile')) return;

                if (!work.classList.contains('_active')) {
                    const activeWork = holder.querySelector('.js-works-item._active');

                    if (activeWork) activeWork.classList.remove('_active');
                    work.classList.add('_active');
                    event.preventDefault();
                }
            });
        });
    });

};